import {
  customerSupportTopbarSize,
  defaultPaddingLeft,
  mobileDefaultPaddingLeft
} from '../../../constants/sizes';
import Device from '../../../constants/deviceSizes';

const iconSize = 35;

export default {
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: `25px ${defaultPaddingLeft}px 0px`,
    [Device.desktop_tablet]: {
      height: customerSupportTopbarSize
    },
    [Device.mobile]: {
      padding: `25px ${mobileDefaultPaddingLeft}px 0px`,
      flexWrap: 'wrap'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center'
  },
  icon: {
    height: iconSize,
    width: iconSize,
    marginRight: 15
  },
  iconInverted: {
    height: iconSize,
    width: iconSize,
    marginRight: 15,
    filter: 'invert(100%)'
  }
};
